import createCachedSelector from 're-reselect';

import { BettingEntitiesSelectors } from 'app/lib/betting/betting-entities';
import { orderByGlobalPriority } from 'app/lib/grid';
import { sortByPriority } from 'app/lib/sortByPriorityImmutableData';

export default (
  matches: BettingEntitiesSelectors['matches'],
  getTournamentsFromUnionsSelector: BettingEntitiesSelectors['getTournamentsFromUnionsSelector'],
  getStagesFromUnionsSelector: BettingEntitiesSelectors['getStagesFromUnionsSelector'],
) => {
  return createCachedSelector(
    matches,
    getTournamentsFromUnionsSelector,
    getStagesFromUnionsSelector,
    (matchesById, tournaments, stages) => {
      if (!tournaments || !stages) {
        return new Map();
      }

      const sortedTournaments = sortByPriority(tournaments);
      const sortedStages = sortByPriority(stages);
      const stagesByUnionSortedByTournamentPriority = new Map();

      sortedTournaments.forEach((tournament) => {
        sortedStages.forEach((stage) => {
          if (stage.tournamentId === tournament.id) {
            stagesByUnionSortedByTournamentPriority.set(
              stage.id,
              new Set(orderByGlobalPriority(matchesById, [...stage.matchIds])),
            );
          }
        });
      });

      return stagesByUnionSortedByTournamentPriority;
    },
  )((_state, tournamentUnionId) => tournamentUnionId);
};
